/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import {
  IconDownload,
  IconEye,
  IconPlus,
  IconDotsVertical,
} from "@tabler/icons-react";
import ToggleButton from "../../components/ToggleButton";
import ListView from "./ListView";
import GridView from "../../components/common/GridView";
import NormalSearch from "../../components/common/NormalSearch";
import ColumnsFilter from "../../components/common/ColumnsFilter";
import { useForm } from "react-hook-form";
import useDebounce from "../../utilities/useDebounce";
import toast from "react-hot-toast";
import TableSkeleton from "../../components/skeleton/TableSkeleton";
import Pagination from "../../components/common/Pagination";
import { useDriverDeleteMutation } from "../../apis/driverApis";
import formatDate from "../../utilities/helper";
import { useNavigate } from "react-router-dom";
import MessageModal from "../../components/MessageModal";
import NewCommonModal from "../../components/common/NewCommonModal";
import NoDataFound from "../../components/common/NoDataFound";
import DriverBulkUploadModals from "../Users/_components/DriverBulkUploadModals";
import DriverBulkResponseModals from "../Users/_components/DriverBulkResponseModals";
import { useSelector } from "react-redux";
import EntriesSelector from "../../components/common/EntriesSelector";
import { handleDownload } from "../../utilities/downloadHelper";
import { usePermission } from "../../hooks/usePermissionTabs";
import AddDarkStoreModal from "./AddDarkStoreModal";
import {
  useDarkStoreAddRadiusMutation,
  useDarkStoreCreateMutation,
  useDarkStoreDriverAssignmentTypeMutation,
  useDarkStoreRadiusCreateMutation,
  useDarkStoreStatusMutation,
  useFetchDarkStoresData,
} from "../../apis/darkStoreApi";
import AddDriverAssigmentTypeModal from "./AddDriverAssignmentMode";
import CommonModal from "../../components/common/CommonModal";
import AddRadiusModal from "./AddRadiusModal";

type DriverData = {
  id: string;
  name: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
  address?: string;
};

type FormValues = {
  storeName: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
  address?: string;
  pinCode: string;
  latitude: string;
  longitude: string;
  shortAddress: string;
  fullAddress: string;
  storeCode?: string;
};

export default function DarkStoreManagement() {
  const { allowed: canCreateDriver, isLoading } = usePermission(
    "dark_store",
    "create",
  );
  const [viewMode, setViewMode] = useState<string>(
    () => localStorage.getItem("DarkStoreModeActiveRole") || "list",
  );
  useEffect(() => {
    localStorage.setItem("DarkStoreModeActiveRole", viewMode);
  }, [viewMode]);

  const [credential, setCredential] = useState<boolean>(false);
  const [openResponse, SetOpenResponse] = useState<boolean | string>(false);
  const [driverBulkResponse, setDriverBulkResponse] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [allSelectedData, setAllSelectedData] = useState<DriverData[]>([]);
  const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);
  const [openDriverAssignmentModal, setOpenDriverAssignmentModal] =
    useState<boolean>(false);
  const [openRadiusModal, setOpenRadiusModal] = useState<boolean>(false);
  const [darkStore, setDarkStore] = useState<any>();

  const credentialToggleModal = () => {
    setParentId("");
    setCredential(!credential);
    if (!credential) {
      reset();
    }
  };

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm<FormValues>();

  const {
    register: addDriverAssignmentTypeRegister,
    handleSubmit: handleSubmitDriverAssignmentType,
    clearErrors: driverAssignmentTypeClearErrors,
    reset: driverAssignmentTypeReset,
    setValue: setDriverAssignmentTypeValue,
    watch: driverAssignmentTypeWatch,
    control: driverAssignmentTypeControl,
    formState: { errors: driverAssignmentTypeErrors },
  } = useForm<any>();

  const {
    register: addRadiusRegister,
    handleSubmit: handleSubmitRadius,
    clearErrors: radiusClearErrors,
    reset: radiusReset,
    setValue: setRadiusValue,
    watch: radiusWatch,
    control: radiusControl,
    formState: { errors: radiusErrors },
  } = useForm<any>();

  const [isOpen, setIsOpen] = useState(false);
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [id, setId] = useState<string>("");
  const [parentId, setParentId] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [activeDeleteModal, setActiveDeleteModal] = useState<boolean>(false);
  const { mutate, isPending } = useDarkStoreCreateMutation();
  const { mutate: statusMutate, isPending: isStatusPending } =
    useDarkStoreStatusMutation(id);
  const { mutate: deleteMutate, isPending: isDeletePending } =
    useDriverDeleteMutation(id);
  const {
    mutate: driverAssignmentTypeMutate,
    isPending: isDriverAssignmentTypePending,
  } = useDarkStoreDriverAssignmentTypeMutation(id);
  const { mutate: addRadiusMutate, isPending: isAddRadiusPending } =
    useDarkStoreAddRadiusMutation(id);
  const { mutate: createRadius, isPending: isRadiusCreatePending } =
    useDarkStoreRadiusCreateMutation();
  const {
    isPending: listPending,
    isFetching,
    refetch,
  } = useFetchDarkStoresData(pageNo, limit, searchFor);

  const data = useSelector((state: any) => state?.darkStores?.data);

  const [allIds, setAllIds] = useState<any>();
  const getIds = (data: any) => {
    setAllIds(data);
  };

  const handleCreate = (data: any) => {
    if (data?.storeCode) {
      delete data?.storeCode;
      delete data?.storeName;
    }

    mutate(
      {
        ...data,
        parentId: parentId ? parentId : null,
        photo: data?.photo ? data?.photo : null,
      },
      {
        onSuccess: () => {
          credentialToggleModal();
          reset();
          refetch();
          toast.success("Dark Store Added Successfully.");
        },
        onError: (error: any) => {
          console.error(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  useEffect(() => {
    if (data?.darkStores) {
      setAllSelectedData((prev) => {
        const filteredPrev = prev.filter((item: any) =>
          selectedRows.includes(item.id),
        );
        const newSelected = data.darkStores.filter(
          (s: any) =>
            selectedRows.includes(s.id) &&
            !filteredPrev.some((item) => item.id === s.id),
        );
        return [...filteredPrev, ...newSelected];
      });
    }
  }, [data?.darkStores, selectedRows]);

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit]);

  const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
    null,
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpenDropdownIndex(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    if (id && status !== "") {
      const newActiveState = typeof status === "boolean"
        ? !status
        : (status !== "ACTIVE");
      statusMutate(
        { isActive: newActiveState },
        {
          onSuccess: (data) => {
            refetch();
            setId("");
            setStatus("");
          },
          onError: (error) => {
            console.log(error, "error");
            toast.error(`${error}`);
            setId("");
            setStatus("");
          },
        },
      );
    }
  }, [id, status]);

  const deleteDriver = () => {
    deleteMutate(undefined, {
      onSuccess: (data) => {
        setActiveDeleteModal(false);
        refetch();
        toast.success("Driver deleted successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to delete driver");
      },
    });
  };

  const [openbluk, SetOpenBluk] = useState<boolean | string>(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [columnsData, setColumnsData] = useState([
    { text: "Checkbox", value: "checkbox", isShow: showCheckboxes },
    { text: "S/N", value: "sn", isShow: true },
    { text: "Store Name", value: "name", isShow: true },
    { text: "Store Code", value: "storeCode", isShow: true },
    { text: "City", value: "cityName", isShow: true },
    { text: "District", value: "districtName", isShow: true },
    { text: "Full Address", value: "fullAddress", isShow: true },
    { text: "Created By", value: "createdBy", isShow: true },
    { text: "Date", value: "date", isShow: true },
    { text: "Status", value: "status", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  const handleSelectRow = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data?.darkStores?.length) {
      setSelectedRows((prev) =>
        prev.filter((id) => !data?.darkStores?.some((s: any) => s.id === id)),
      );
    } else {
      const newSelections =
        data?.darkStores
          ?.filter((s: any) => !selectedRows.includes(s.id))
          .map((s: any) => s.id) || [];
      setSelectedRows((prev) => [...prev, ...newSelections]);
    }
  };
  const tableRows = (() => {
    const rows: any[] = [];
    let parentIndex = 0;

    data?.darkStores?.forEach((parent: any) => {
      rows.push({ ...parent, _isBranch: false, _parentIndex: parentIndex + 1 });
      if (parent.branches && parent.branches.length > 0) {
        parent.branches.forEach((branch: any) => {
          rows.push({
            ...branch,
            _isBranch: true,
            parentName: parent.name,
            _parentIndex: parentIndex + 1,
          });
        });
      }

      parentIndex++;
    });

    return rows;
  })();

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "checkbox":
          return {
            label: (
              <div className="flex justify-center">
                <input
                  type="checkbox"
                  checked={data?.darkStores?.every((s: any) =>
                    selectedRows.includes(s.id),
                  )}
                  onChange={handleSelectAll}
                  className="h-4 w-4 rounded border-gray-300 text-[#FBD037] focus:ring-[#FBD037]"
                />
              </div>
            ),
            render: (c: any) => (
              <div className="flex justify-center">
                <input
                  type="checkbox"
                  checked={selectedRows.includes(c.id)}
                  onChange={() => handleSelectRow(c.id)}
                  className="h-4 w-4 rounded border-gray-300 text-[#FBD037] focus:ring-[#FBD037]"
                />
              </div>
            ),
          };

        case "sn":
          return {
            label: "#",
            render: (c: any, _i: number, isBranch: boolean) => (
              <div className="text-center font-medium text-gray-700">
                {isBranch ? "" : c._parentIndex}
              </div>
            ),
          };

        case "name":
          return {
            label: "Store Name",
            render: (c: any, _i: number, isBranch: boolean) => (
              <div className="flex items-center gap-2.5">
                {isBranch ? (
                  <>
                    <span className="text-gray-600 font-medium truncate max-w-[220px]">
                      {`Branch`}
                    </span>
                  </>
                ) : (
                  <>
                    <img
                      src={c.photo || "/img/dummy-blank-profile.png"}
                      alt=""
                      className="w-10 h-10 rounded-full object-cover border border-gray-200"
                    />
                    <span className="font-medium truncate max-w-[220px]">
                      {c.name}
                    </span>
                  </>
                )}
              </div>
            ),
          };

        case "storeCode":
          return {
            label: "Store Id",
            render: (c: any) => (
              <span className="text-gray-700">{c.storeCode || "—"}</span>
            ),
          };

        case "cityName":
          return {
            label: "City",
            render: (c: any) => c.cityName || "—",
          };

        case "districtName":
          return {
            label: "District",
            render: (c: any) => c.districtName || "—",
          };

        case "fullAddress":
          return {
            label: "Full Address",
            render: (c: any) => (
              <div className="max-w-[160px] truncate" title={c.fullAddress}>
                {c.fullAddress || c.shortAddress || "—"}
              </div>
            ),
          };

        case "createdBy":
          return {
            label: "Created By",
            render: (c: any) => c.createdBy || "—",
          };

        case "date":
          return { label: "Date", render: (c: any) => formatDate(c.createdAt) };

        case "status":
          return {
            label: "Status",
            render: (c: any) => (
              <div className="">
                <ToggleButton
                  onChange={() => {
                    setId(c.id);
                    setStatus(c.isActive);
                  }}
                  checked={c.isActive}
                />
              </div>
            ),
          };
        case "actions":
          return {
            label: "Actions",
            render: (c: any) => {
              const isBranch = c._isBranch === true;
              return (
                <div className="relative ">
                  <button
                    onClick={() =>
                      setOpenDropdownIndex(
                        openDropdownIndex === c.id ? null : c.id,
                      )
                    }
                    className="p-2 border rounded-full bg-[#F7F6F2]"
                  >
                    <IconDotsVertical size={22} />
                  </button>

                  {openDropdownIndex === c.id && (
                    <div
                      ref={dropdownRef}
                      className="absolute bg-[#F7F6F2] divide-y right-20 text-left -top-4 z-50 mt-2 w-fit whitespace-nowrap rounded-xl shadow-lg overflow-hidden"
                    >
                      <div
                        className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                        onClick={() => navigate(`/dark-store/${c.id}`)}
                      >
                        View Details
                      </div>

                      {!isBranch && (
                        <div
                          onClick={() => {
                            setParentId(c?.id);
                            setValue("storeCode", c?.storeCode);
                            setCredential(true);
                          }}
                          className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                        >
                          Add Branch
                        </div>
                      )}

                      <div
                        className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                        onClick={() => {
                          setId(c?.id);
                          setDarkStore(c);
                          if (c?.driverAssignmentType) {
                            setDriverAssignmentTypeValue(
                              "driverAssignmentType",
                              c?.driverAssignmentType,
                            );
                          }
                          setOpenDriverAssignmentModal(true);
                        }}
                      >
                        {c?.driverAssignmentType ? "Update" : "Add"} Dri. A.Type
                      </div>

                      {c?.driverAssignmentType && (
                        <div
                          className="px-4 py-2 text-[#404040] hover:bg-[#FBD037] cursor-pointer"
                          onClick={() => {
                            setId(c?.id);
                            setDarkStore(c);
                            setOpenRadiusModal(true);
                            if (c?.deliveryRadius) {
                              setRadiusValue(
                                "deliveryRadius",
                                c?.deliveryRadius,
                              );
                            }

                            if (c?.pickupRadius) {
                              setRadiusValue("pickupRadius", c?.pickupRadius);
                            }
                          }}
                        >
                          {c?.pickupRadius || c?.deliveryRadius
                            ? "Update"
                            : "Add"}{" "}
                          Radius
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            },
          };

        default:
          return { label: "", render: () => null };
      }
    });

  const mapDataToExport = (c: any, index: number) => ({
    "S/N": index + 1,
    "Store Name": c.name || c.name,
    "Store Id": c.storeCode,
    "Driver Assignment": c?.driverAssignmentType,
    City: c?.cityName,
    District: c?.districtName,
    "Full Address": c?.fullAddress,
    "Created By": c?.createdBy,
    Date: formatDate(c.createdAt),
    Status: c?.isActive ? "ACTIVE" : "INACTIVE",
  });

  const handleAddDriverAssignmentType = async (data: any) => {
    driverAssignmentTypeMutate(
      { ...data },
      {
        onSuccess: (data) => {
          driverAssignmentTypeReset();
          setOpenDriverAssignmentModal(false);
          toast.success(
            `Driver Assignment Type ${darkStore?.driverAssignmentType ? "Updated" : "Added"} Successfully`,
          );
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };

  const handleAddRadius = async (data: any) => {
    createRadius(
      { ...data, darkStoreId: id },
      {
        onSuccess: (data) => {
          radiusReset();
          setOpenRadiusModal(false);
          toast.success(
            `Radius ${darkStore?.pickupRadius || darkStore?.deliveryRadius ? "Updated" : "Added"} Successfully`,
          );
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };

  return (
    <>
      <div className=" rounded-3xl px-6">
        <div className="flex items-center ">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
            <h1 className="text-2xl text-[#212121] tracking-[-0.5px] font-medium">
              Dark Store
            </h1>
            <div className="flex items-center gap-2">
              {data && data.totalPages * limit > 10 && (
                <EntriesSelector
                  value={limit}
                  options={[
                    10,
                    ...(data.totalPages * limit > 10 ? [20] : []),
                    ...(data.totalPages * limit > 20 ? [30] : []),
                    ...(data.totalPages * limit > 50 ? [50] : []),
                    ...(data.totalPages * limit > 100 ? [100] : []),
                  ]}
                  onChange={(val) => {
                    setLimit(val);
                    setPageNo(1);
                  }}
                />
              )}
              <ColumnsFilter
                columnsData={columnsData.filter((c) => c.value !== "checkbox")}
                setHeadings={setHeadings}
              />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button
                onClick={() =>
                  handleDownload({
                    selectedRows,
                    allSelectedData,
                    setSelectedRows,
                    setAllSelectedData,
                    showCheckboxes,
                    setShowCheckboxes,
                    setColumnsData,
                    mapDataToExport,
                    fileName: "dark_stores.xlsx",
                  })
                }
                className={`flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] ${
                  showCheckboxes && selectedRows.length === 0
                    ? "bg-[#F7F6F2]/50 text-[#404040]/50"
                    : "bg-[#F7F6F2] text-[#404040]"
                }`}
              >
                <IconDownload stroke={1.5} size={24} />
                {selectedRows?.length > 0 && (
                  <span>({selectedRows?.length})</span>
                )}
              </button>

              <div
                className="relative inline-block text-left"
                ref={dropdownRef}
              >
                {/* {canCreateDriver && ( */}
                <button
                  onClick={() => setOpen(true)}
                  className="flex items-center gap-1  p-2.5  text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]"
                >
                  <IconPlus stroke={1.5} size={24} />
                </button>
                {/* )} */}

                {open && (
                  <div className="absolute mt-2 right-0 w-[160px] rounded-md shadow-lg border border-[#D8D8D8] bg-[#F7F6F2] text-[#404040] z-50">
                    <div className="py-1 divide-y divide-[#D8D8D8]">
                      <button
                        onClick={credentialToggleModal}
                        className="w-full text-left px-4 py-2 text-sm hover:bg-[#FBD037] cursor-pointer"
                      >
                        Add Dark Store
                      </button>
                    </div>
                    <div className="py-1 divide-y divide-[#D8D8D8]">
                      <button
                        onClick={() => SetOpenBluk(true)}
                        className="w-full text-left px-4 py-2 text-sm hover:bg-[#FBD037] cursor-pointer"
                      >
                        Bluk Upload
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="">
          {viewMode === "list" ? (
            <>
              {listPending || isFetching ? (
                <TableSkeleton
                  columns={columnsData
                    .filter((c) => c.isShow)
                    .map((c) => c.text)}
                  rows={6}
                />
              ) : tableRows && tableRows?.length > 0 ? (
                <ListView
                  data={data?.darkStores}
                  onRowClick={(item) => console.log("Clicked:", item)}
                  columns={columns}
                  getBranches={(item) => item.branches}
                />
              ) : (
                <NoDataFound />
              )}
            </>
          ) : (
            <>
              {data?.darkStores && data?.darkStores?.length > 0 ? (
                <GridView
                  data={data?.darkStores}
                  columns={5}
                  className="p-2 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 "
                  renderItem={(client: any) => (
                    <div className="rounded-2xl p-4 transition-all bg-[#FCFDF8] scale-100 hover:scale-105  space-y-4">
                      <div className="flex justify-between items-center">
                        {client.status === "ACTIVE" && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setId(client?.id);
                              setStatus(client?.status);
                            }}
                            className="text-sm text-[212121] px-4 py-1 bg-[#20BF55]/20 border-[#20BF55] border rounded-lg capitalize cursor-pointer"
                          >
                            {client?.status?.toLowerCase()}
                          </button>
                        )}
                        {client.status === "INACTIVE" && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setId(client?.id);
                              setStatus(client?.status);
                            }}
                            className="text-sm text-[212121] px-4 py-1 bg-red-500/20 border-red-500 border rounded-lg capitalize cursor-pointer"
                          >
                            {client?.status?.toLowerCase()}
                          </button>
                        )}
                        <button
                          onClick={() => navigate(`/driver/${client.id}`)}
                          className="p-1 border rounded-full bg-[#F7F6F2]"
                        >
                          <IconEye size={22} />
                        </button>
                      </div>

                      <div className="flex items-center flex-col w-full gap-2 justify-center">
                        <img
                          src={client?.image || "/img/dummy-blank-profile.png"}
                          className="size-20 rounded-full object-cover border"
                          alt={client.name}
                        />

                        <div className="w-full">
                          <h2
                            className="text-[#212121] text-center 2xl:text-xl text-lg font-medium line-clamp-1 "
                            title={client.name}
                          >
                            {client.name}
                          </h2>
                          <p className="text-[#212121]/80 text-center text-sm">
                            Driver Id: {client.driverCode}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                />
              ) : (
                <NoDataFound />
              )}
            </>
          )}
          <div className="flex justify-center items-center py-4">
            {data?.totalPages > 1 && (
              <Pagination
                currentPage={pageNo}
                totalPages={data.totalPages}
                fetchData={handlePaginationFetch}
              />
            )}
          </div>
        </div>
      </div>

      <NewCommonModal
        title={`Add ${parentId ? `${data?.darkStores?.find((store: any) => store?.id === parentId)?.name} Branch` : "Dark Store"}`}
        open={credential}
        closeButtonText={"Cancel"}
        onClose={credentialToggleModal}
        actionButtonText={"Add"}
        actionButtonOnClick={handleSubmit(handleCreate)}
        isPending={isPending}
      >
        <AddDarkStoreModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          getIds={getIds}
          watch={watch}
          control={control}
          parentId={parentId}
        />
      </NewCommonModal>

      <CommonModal
        title={`${darkStore?.driverAssignmentType ? "Update" : "Add"} Driver Assignment Type`}
        open={openDriverAssignmentModal}
        closeButtonText={"Cancel"}
        onClose={() => {
          driverAssignmentTypeReset();
          setOpenDriverAssignmentModal(false);
        }}
        actionButtonText={darkStore?.driverAssignmentType ? "Update" : "Add"}
        actionButtonOnClick={handleSubmitDriverAssignmentType(
          handleAddDriverAssignmentType,
        )}
        isPending={isDriverAssignmentTypePending}
      >
        <AddDriverAssigmentTypeModal
          register={addDriverAssignmentTypeRegister}
          errors={driverAssignmentTypeErrors}
          setValue={setDriverAssignmentTypeValue as any}
          watch={driverAssignmentTypeWatch}
          clearErrors={driverAssignmentTypeClearErrors as any}
          control={driverAssignmentTypeControl}
        />
      </CommonModal>

      <CommonModal
        title={`${darkStore?.pickupRadius || darkStore?.deliveryRadius ? "Update" : "Add"} Radius`}
        open={openRadiusModal}
        closeButtonText={"Cancel"}
        onClose={() => {
          radiusReset();
          setOpenRadiusModal(false);
        }}
        actionButtonText={
          darkStore?.pickupRadius || darkStore?.deliveryRadius
            ? "Update"
            : "Add"
        }
        actionButtonOnClick={handleSubmitRadius(handleAddRadius)}
        isPending={isAddRadiusPending}
      >
        <AddRadiusModal
          register={addRadiusRegister}
          errors={radiusErrors}
          setValue={setRadiusValue as any}
          watch={radiusWatch}
          clearErrors={radiusClearErrors as any}
          darkStore={darkStore}
        />
      </CommonModal>



      <MessageModal
        open={activeDeleteModal}
        onClose={() => setActiveDeleteModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to delete this driver?"
        img={"/img/inactive.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={deleteDriver}
        isPending={isDeletePending}
        size="md"
      />

      {openbluk && (
        <DriverBulkUploadModals
          onClose={() => SetOpenBluk(false)}
          onResponseOpene={() => SetOpenResponse(true)}
          setDriverBulkResponse={setDriverBulkResponse}
        />
      )}

      {openResponse && driverBulkResponse && (
        <DriverBulkResponseModals
          data={driverBulkResponse}
          onClose={() => SetOpenResponse(false)}
        />
      )}
    </>
  );
}
